// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dIvi","content":"styles_content__2oHfB","tableWrap":"styles_tableWrap__z4Gyg"};